import React from "react";
import _device_service from "../../services/DeviceService";
import './SpeechBubble.scss';

interface SpeechBubbleProps {
    text: string,
}

const SpeechBubble = (props: SpeechBubbleProps) => {

    const getTailLocation = (): 'left' | 'right' | 'middle' => {
        return _device_service.isMobileWidth() ? 'middle' : 'right';
    }

    return (
        <div className={`speech-bubble tail-${getTailLocation()}`}>
            <div>
                <span>{props.text}</span>
            </div>
        </div>
    );
}

export default SpeechBubble;